
import React, { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import logo from '../logo.png';

const PrivacyPage = () => {
  const [content, setContent] = useState('');

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + '/chinh-sach-va-dieu-khoan.md')
      .then((res) => res.text())
      .then((text) => setContent(text));
  }, []);

  return (
    <div style={{ maxWidth: 800, margin: '40px auto', padding: 24, background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
      <div style={{ textAlign: 'center', marginBottom: 24 }}>
        <img src={logo} alt="Tedy Game Logo" style={{ width: 100, height: 'auto' }} />
      </div>
      <div className="markdown-body" style={{ fontSize: 16 }}>
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
      </div>
    </div>
  );
};

export default PrivacyPage;
